<div class="social-media-setup">
  <div class="social-icons-grid">
    <div class="icon-item" *ngFor="let icon of allIcons.slice(0, 4); trackBy: trackByPlatform">
      <label [class.selected]="icon.selected" (click)="toggleSocialIcon(icon)">
        <div [innerHTML]="getSafeHtml(icon.imageUrl)" class="social-icon-html"></div>
        <mat-icon class="check-icon" *ngIf="icon.selected">check_circle</mat-icon>
      </label>
      <input *ngIf="icon.selected" 
             type="url" 
             [value]="getSocialMediaUrl(icon.platform)" 
             (input)="updateSocialMediaUrl(icon.platform, $event)"
             (click)="$event.stopPropagation()"
             class="profile-link-input">
    </div>

    <ng-container *ngIf="showAllSocialIcons">
      <div class="icon-item" *ngFor="let icon of allIcons.slice(4); trackBy: trackByPlatform">
        <label [class.selected]="icon.selected" (click)="toggleSocialIcon(icon)">
          <div [innerHTML]="getSafeHtml(icon.imageUrl)" class="social-icon-html"></div>
          <mat-icon class="check-icon" *ngIf="icon.selected">check_circle</mat-icon>
        </label>
        <input *ngIf="icon.selected" 
               type="url" 
               [value]="getSocialMediaUrl(icon.platform)" 
               (input)="updateSocialMediaUrl(icon.platform, $event)"
               (click)="$event.stopPropagation()"
               class="profile-link-input">
      </div>
    </ng-container>

    <div class="icon-item" *ngIf="!showAllSocialIcons">
      <label class="show-more-label" (click)="toggleShowMore()">
        <span class="more-text">{{ 'onboarding.step2.showMore' | translate }}</span>
      </label>
    </div>
  </div>

  <div class="custom-icons-section" *ngIf="customIcons.length > 0">
    <h4 class="section-title">{{ 'onboarding.step2.customIcons' | translate }}</h4>
    <div class="social-icons-grid">
      <div class="icon-item" *ngFor="let icon of customIcons; trackBy: trackByPlatform">
        <label [class.selected]="icon.selected" (click)="toggleSocialIcon(icon)">
          <img [src]="icon.imageUrl" [alt]="icon.alt" class="custom-icon-image">
          <mat-icon class="check-icon" *ngIf="icon.selected">check_circle</mat-icon>
        </label>
        <input *ngIf="icon.selected" 
               type="url" 
               [value]="icon.url" 
               (input)="updateCustomIconUrl(icon, $event)"
               (click)="$event.stopPropagation()"
               class="profile-link-input">
      </div>
    </div>
  </div>

  <div class="add-custom-icon-section" *ngIf="showAllSocialIcons">
    <button mat-stroked-button class="add-custom-btn" (click)="showAddCustomIconForm()">
      <mat-icon>add</mat-icon>
      {{ 'onboarding.step2.addCustomIcon' | translate }}
    </button>
  </div>
</div>